import * as React from "react";

import { formatCurrency } from "../../../lib/common";
import { getCart } from "../cartRepo";

interface cartCountProps {
    count: number,
    total: number
}

// displays the shopping cart icon with a count of items in the cart
const CartCount: React.FC<cartCountProps> = (props: cartCountProps) => {

    const [total, setTotal] = React.useState(props.total);
    const [count, setCount] = React.useState(props.count);

    React.useEffect(() => {

        const updateCart = async () => {
            const cart = await getCart();
            
            let count = 0;
            count = cart.Items.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0);

            setCount(count);
            setTotal(cart.MerchandiseTotal);
        };

        document.addEventListener("addToCart", updateCart);

        return () => {
            document.removeEventListener("addToCart", updateCart);
        };

    },[total])

    return (
        <div>
            <a href="/shoppingcart.aspx">
                <img src="https://cdn1.hospitalgiftshop.com/hgs-img/icons/shopping-cart-icon.svg" height="20" width="25" alt="Shopping Cart" />
            </a>
            <span>{count}</span>
            <span>Item{count === 1 ? '' : 's'}</span >
            <span>Total:</span>
            <span>{formatCurrency(total)} </span>
        </div>
    );

}

export default CartCount;
